import { Controller } from "@hotwired/stimulus"

// Copies the value of a source input to the clipboard and gives brief feedback
// on the button. Used by the shared "copy field" input group (pay links, etc.).
export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    const text = this.sourceTarget.value
    const done = () => this.flash()

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(done, () => this.fallbackCopy(text, done))
    } else {
      this.fallbackCopy(text, done)
    }
  }

  // execCommand path for non-HTTPS / older browsers.
  fallbackCopy(text, done) {
    this.sourceTarget.removeAttribute("readonly")
    this.sourceTarget.select()
    try {
      // execCommand returns false when the copy didn't happen — don't claim success then.
      if (document.execCommand("copy")) done()
    } finally {
      this.sourceTarget.setAttribute("readonly", "readonly")
    }
  }

  flash() {
    if (!this.hasButtonTarget) return
    const original = this.buttonTarget.innerHTML
    this.buttonTarget.innerHTML = '<i class="fa fa-check"></i> Copied'
    setTimeout(() => { this.buttonTarget.innerHTML = original }, 1500)
  }
}
